/*
 * Module for the Correspondence Packet Review packet tab.
 */
rs.module("content/participant/correspondencepacketreview/packettab",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        var _executeSelectionChanged;

        // initialize the module
        function initialize(jsSelectors, reviewPacketKey, reviewPacketStatus, grid, ajaxUrl) {

            // Unpack jsSelectors
            var criteria = $.js(jsSelectors.criteria);
            var correspondenceDetailContent = criteria.js(jsSelectors.correspondenceDetailContent);

            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    eventBanner.removeAllMessages();

                    $.get(
                        ajaxUrl,
                        { reviewItemKey: values[0], reviewPacketKey: reviewPacketKey, reviewPacketStatus: reviewPacketStatus },
                        function (data) {
                            // Reload partial with data
                            correspondenceDetailContent.html(data);
                        }
                    );
                }

                _executeSelectionChanged = true;
            });

        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);